var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.91 29.5h24.18c2.23 0 3.037.232 3.852.668a4.543 4.543 0 011.89 1.89c.436.815.668 1.623.668 3.852v16.18c0 2.23-.232 3.037-.668 3.852a4.543 4.543 0 01-1.89 1.89c-.815.436-1.623.668-3.852.668H19.91c-2.23 0-3.037-.232-3.852-.668a4.543 4.543 0 01-1.89-1.89c-.436-.815-.668-1.623-.668-3.852V35.91c0-2.23.232-3.037.668-3.852a4.543 4.543 0 011.89-1.89c.815-.436 1.623-.668 3.852-.668z",
    fillOpacity: 0.2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 5.5c7.456 0 13.5 6.044 13.5 13.5v10.5h0-27V19c0-7.456 6.044-13.5 13.5-13.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 32,
    cy: 42,
    r: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 30.5,
    y: 42,
    width: 3,
    height: 8,
    rx: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock64);
export default __webpack_public_path__ + "static/media/lock-64.feb109a4.svg";
export { ForwardRef as ReactComponent };